export default __webpack_public_path__ + "static/media/brakekit-lime.0b5fc42a.webp";